import React from "react";
import BlogArticlesCollection from "../../components/Blog/BlogArticlesCollection";

export const CollectionRenderer = ({ collection }: { collection: any }) => {
  console.log("CollectionRenderer rendering with:", collection);
  console.log("BlogMapper - collection data:", {
    title: collection.title,
    articlesCount: collection?.blog_articles?.length,
    fullData: collection,
  });

  if (!collection?.blog_articles) return null;

  return (
    <BlogArticlesCollection
      title={collection.title || ""}
      articles={collection.blog_articles}
    />
  );
};
